import React from "react";
import image from "../../Images/web-design/image.jpg"; // reuse same bg for consistency
import icon1 from "../../Images/web-design/1.png";
import icon2 from "../../Images/web-design/2.png";
import icon3 from "../../Images/web-design/3.png";
import icon4 from "../../Images/web-design/4.png";
import icon5 from "../../Images/web-design/5.png";
import icon6 from "../../Images/web-design/6.png";
import CalendlyButton from "../Shared/CalendlyButton";
const Offers = () => {
const bulletPoints = [
  {
    icon: icon1,
    text: "Individuelle Entwicklung statt vorgefertigter Themes",
  },
  {
    icon: icon2,
    text: "SEO-optimierter Code für bessere Google-Rankings",
  },
  {
    icon: icon3,
    text: "Conversion-starkes UX/UI-Design",
  },
  {
    icon: icon4,
    text: "Performance & Ladezeiten auf Top-Niveau",
  },
  {
    icon: icon5,
    text: "Responsives Webdesign für Desktop, Tablet & Smartphone",
  },
  {
    icon: icon6,
    text: "Skalierbar & zukunftssicher",
  },
];

  return (
    <section>
      <div className=" w-[90%] 2xl:w-[70%]  mx-auto  flex flex-col md:flex-row items-center pt-4 md:pt-16 gap-16">
        {/* Left side content */}
        <div className="flex-1 text-left mx-auto">
          <h2 className="h2-mb h2-md h2-lg h2-2xl mb-4">
            <span className="">Warum unser Webdesign überzeugt:</span>
          </h2>

          {/* Bullet points */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
  {bulletPoints.map((item, index) => (
    <div
      key={index}
      className="
        flex items-start gap-4
        bg-white
        border border-gray-200
        rounded-2xl
        p-4
        shadow-sm
        hover:shadow-md
        hover:-translate-y-1
        transition-all duration-300
        flex-col
      "
    >
      {/* Icon badge */}
      <div
        className="
          min-w-[48px] h-[48px]
          flex items-center justify-center
          rounded-xl
          
        
        "
      >
        <img src={item.icon} alt="" className="w-20 h-20 object-cover" />
      </div>

      {/* Text */}
      <p className="text-gray-700 leading-relaxed">
        {item.text}
      </p>
    </div>
  ))}
</div>

        </div>

        {/* Right side image */}
        <div className="flex-1 flex justify-center md:justify-end">
          <img
            src={image}
            alt="image"
            className="rounded-xl shadow-lg w-full max-w-md object-cover"
          />
        </div>
      </div>
      <div className="mt-12">
        <CalendlyButton text="Kostenloses Erstgespräch" />
      </div>
    </section>
  );
};

export default Offers;
